
import { https , httpsFile } from './http.js' ;

export function index(){
    return https().get(`change_logs`);
}
export function getLatestLogs(){
    return https().get(`getLatestLogs`);
}

export function getChanges(id){
    return https().get(`getChanges?id=${id}`);
}

export function store ( changeLogs ) {
    return httpsFile().post( 'change_logs' , changeLogs )
}

export function update ( changeLogs  ) {
    return httpsFile().post( `updateChangeLog` , changeLogs )
}


export function destroy ( log ) {
    return httpsFile().delete( `/change_logs/${log}` )
}